// extracted by mini-css-extract-plugin
module.exports = {"fixWidth":"EffectiveSplit_fixWidth___RTZ0","btnWrapper":"EffectiveSplit_btnWrapper__sK9_5"};